import { memo, type PropsWithChildren, type ReactElement } from 'react';
import { Skeleton, type SkeletonProps } from '@mui/material';

export const SkeletonChip = memo((props: PropsWithChildren<SkeletonProps>): ReactElement => {
  return <Skeleton {...props} sx={{ borderRadius: 16, width: 100, height: 32, transform: 'none', ...props.sx }} />;
});
